import React, { FC } from 'react';
import pageWrapper from '../../hoc/pageWrapper';
import { IPageViewContentModel } from '../../interfaces/umbracoNodes/pageViewModel';
import PageContentSliceMapper from '../pageContentSlice';

interface Props {
	page: IPageViewContentModel;
}

const Frontpage: FC<Props> = ({ page }) => {
	return <PageContentSliceMapper page={page} />;
};

export default pageWrapper(Frontpage);
